/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiKeyScope } from './ApiKeyScope';
import {
    ApiKeyScopeFromJSON,
    ApiKeyScopeFromJSONTyped,
    ApiKeyScopeToJSON,
    ApiKeyScopeToJSONTyped,
} from './ApiKeyScope';

/**
 * 
 * @export
 * @interface ApiKeyWithOwner
 */
export interface ApiKeyWithOwner {
    /**
     * 
     * @type {number}
     * @memberof ApiKeyWithOwner
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ApiKeyWithOwner
     */
    userId: number;
    /**
     * 
     * @type {number}
     * @memberof ApiKeyWithOwner
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyWithOwner
     */
    name: string;
    /**
     * First characters of the key for identification (the full key is never returned again)
     * @type {string}
     * @memberof ApiKeyWithOwner
     */
    keyPrefix: string;
    /**
     * 
     * @type {Array<ApiKeyScope>}
     * @memberof ApiKeyWithOwner
     */
    scopes: Array<ApiKeyScope>;
    /**
     * 
     * @type {Date}
     * @memberof ApiKeyWithOwner
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiKeyWithOwner
     */
    lastUsedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ApiKeyWithOwner
     */
    revokedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ApiKeyWithOwner
     */
    expiresAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyWithOwner
     */
    ownerName: string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyWithOwner
     */
    ownerEmail: string;
}

/**
 * Check if a given object implements the ApiKeyWithOwner interface.
 */
export function instanceOfApiKeyWithOwner(value: object): value is ApiKeyWithOwner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('keyPrefix' in value) || value['keyPrefix'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('ownerName' in value) || value['ownerName'] === undefined) return false;
    if (!('ownerEmail' in value) || value['ownerEmail'] === undefined) return false;
    return true;
}

export function ApiKeyWithOwnerFromJSON(json: any): ApiKeyWithOwner {
    return ApiKeyWithOwnerFromJSONTyped(json, false);
}

export function ApiKeyWithOwnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiKeyWithOwner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'companyId': json['companyId'],
        'name': json['name'],
        'keyPrefix': json['keyPrefix'],
        'scopes': ((json['scopes'] as Array<any>).map(ApiKeyScopeFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'lastUsedAt': json['lastUsedAt'] == null ? undefined : (new Date(json['lastUsedAt'])),
        'revokedAt': json['revokedAt'] == null ? undefined : (new Date(json['revokedAt'])),
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'ownerName': json['ownerName'],
        'ownerEmail': json['ownerEmail'],
    };
}

export function ApiKeyWithOwnerToJSON(json: any): ApiKeyWithOwner {
    return ApiKeyWithOwnerToJSONTyped(json, false);
}

export function ApiKeyWithOwnerToJSONTyped(value?: ApiKeyWithOwner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'companyId': value['companyId'],
        'name': value['name'],
        'keyPrefix': value['keyPrefix'],
        'scopes': ((value['scopes'] as Array<any>).map(ApiKeyScopeToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
        'lastUsedAt': value['lastUsedAt'] == null ? undefined : ((value['lastUsedAt'] as any).toISOString()),
        'revokedAt': value['revokedAt'] == null ? undefined : ((value['revokedAt'] as any).toISOString()),
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt'] as any).toISOString()),
        'ownerName': value['ownerName'],
        'ownerEmail': value['ownerEmail'],
    };
}

